import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  removeSiteAccessPointSuccess
} from '../../reducers/actions';
import { AccessPointService } from '../../services';
import { apiErrorHandling } from '../../utils/epics/apiErrorHandling';
import updateErrorMsgAction from '../../reducers/error-banner/actions/updateErrorMsg';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_SITE_AP),
    switchMap(action =>
      AccessPointService.deleteSiteAccessPoint(
        action.siteId,
        action.nodeAddress,
        store
      ).pipe(
        map(() => removeSiteAccessPointSuccess(action.nodeAddress)),
        catchError(apiErrorHandling(updateErrorMsgAction))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/status/deleteSiteAccessPoint.js